/**
 * @generated SignedSource<<64b9ebdd5cb7a082d4be0c1430df8782>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrganizationsPage_organization$data = {
  readonly accessPoints: {
    readonly totalCount: number;
  } | null;
  readonly docks: {
    readonly totalCount: number;
  } | null;
  readonly id: string;
  readonly name: string;
  readonly users: {
    readonly totalCount: number;
  } | null;
  readonly uuid: string;
  readonly vehicles: {
    readonly totalCount: number;
  } | null;
  readonly " $fragmentType": "OrganizationsPage_organization";
};
export type OrganizationsPage_organization$key = {
  readonly " $data"?: OrganizationsPage_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrganizationsPage_organization">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrganizationsPage_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VehicleConnection",
      "kind": "LinkedField",
      "name": "vehicles",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "users",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DockConnection",
      "kind": "LinkedField",
      "name": "docks",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccessPointConnection",
      "kind": "LinkedField",
      "name": "accessPoints",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "c875778c0b0e703175d35e628aab23a2";

export default node;
